import React, { Component } from 'react'
import { Container, Row } from  'reactstrap'
import BootstrapTable from "react-bootstrap-table-next"
import ToolkitProvider from 'react-bootstrap-table2-toolkit'
import { observer, inject } from 'mobx-react'
import NovoDirecionamentoCard from './NovoDirecionamentoCard'

@inject("store")
@observer
export default class TabelaAdicoesDirecionamento extends Component {

    constructor(props) {
        super(props)

        this.tituloPaginaStore = this.props.store.tituloPaginaStore
        this.controller = this.props.controller
    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Novos direcionamentos")
    }

    componentWillUnmount() {
        this.tituloPaginaStore.setTitulo("Direcionamento Recinto")
    }

    render() {
        return (
            <Container fluid className="tabela-container">
                <ToolkitProvider
                    keyField="IdAdd"
                    data={[...this.controller.listaAdicoes]}
                    columns={[...this.controller.colunasAdicionar]}
                >
                    {props => (
                        <div>
                            {window.innerWidth > 991
                                ?<BootstrapTable bootstrap4
                                    striped
                                    bordered={false}
                                    //noDataIndication={() => this.controller.noData}
                                    classes="tabela tabela-layout cabotagem"
                                    {...props.baseProps} 
                                
                                />
                                :<Row>
                                    {this.controller.listaAdicoes.map((direcionamento, index) => 
                                        <NovoDirecionamentoCard
                                            controller={this.controller}
                                            key={index}
                                            data={direcionamento}
                                            id={index}
                                            colunas={[...this.controller.colunasAdicionar]}
                                            titulo={"CeHouse"}
                                        />    
                                    )}
                                </Row>
                            }
                        </div>
                    )

                    }
                </ToolkitProvider>
            </Container>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/direcionamento/recinto/components/TabelaAdicoesDirecionamento.js